/**
 * Non recurrent actions
 */
export const CREDITS_ACTION_USER_NOT_AVAILABLE = 'user_not_available';
export const CREDITS_ACTION_JOIN_DATE_REACHED_THRESHOLD = 'joindate_threshold_reached';
export const CREDITS_ACTION_USER_BIRTHDAY = 'user_birthday';
export const CREDITS_ACTION_LISTING_PUBLISHED = 'listing_published';
export const CREDITS_ACTION_PROFILE_VERIFIED = 'profile_verified';
export const CREDITS_ACTION_PROFILE_COMPLETE = 'profile_complete';
export const CREDITS_ACTION_AVAILABILITY_CONFIRMED = 'availability_confirmed';

export const CREDITS_ACTION_INITIAL_PURCHASE = 'initial_purchase';
export const CREDITS_ACTION_NEW_RECOMMENDATION_RECEIVED = 'recommendation_received';
export const CREDITS_ACTION_REFERRAL_INVITER = 'referral_to_inviter';
export const CREDITS_ACTION_REFERRAL_INVITED_USER = 'referral_invited_user';
export const CREDITS_ACTION_VISITOR_INFO_REVEALED = 'visitor_info_revealed';

export const CREDITS_ACTION_FB_CONTENT_SHARED = 'fb_content_shared';
export const CREDITS_ACTION_WHATSAPP_CONTENT_SHARED = 'wa_content_shared';

/** Recurrent actions */
export const CREDITS_ACTION_TOP_UP = 'top_up';
export const CREDITS_ACTION_WITHDRAW = 'withdraw';
export const CREDITS_MODAL_NOTIFICATION = 'credits.notification';

export const CREDITS_SPONSORED_INQUIRY_ACTIVATION = 'sponsored_inquiry_activation';
export const CREDITS_SPONSORED_INQUIRY_REFUND = 'sponsored_inquiry_refund';

export const CREDITS_FLIP_AND_WIN_BONUS_CREDITS = 'flip_and_win_bonus_credits';

export const CREDITS_PACKAGE_1 = 'p_c_30';
export const CREDITS_PACKAGE_2 = 'p_c_150';
export const CREDITS_PACKAGE_3 = 'p_c_300';

export const CREDITS_EXTRA_PACKAGE_SOCIAL_BOOSTING = 'extra_package_social_boosting';
export const CREDITS_EXTRA_PACKAGE_ANONYM_LISTING = 'extra_package_anonymous_listing';
export const CREDITS_EXTRA_PACKAGE_PRIVATE_LISTING = 'extra_package_private_listing';

export const CREDITS_EXTRA_PACKAGE_SOCIAL_BOOST_PROFILE = 'extra_package_social_boosting_profile';
export const CREDITS_EXTRA_PACKAGE_ANONYM_PROFILE = 'extra_package_anonymous_profile';
export const CREDITS_EXTRA_PACKAGE_PRIVATE_PROFILE = 'extra_package_private_profile';

export const creditsConfig = {
    [CREDITS_PACKAGE_1]: {
        id: CREDITS_PACKAGE_1,
        price: '8.90',
        creditsToPurchase: 30,
    },
    [CREDITS_PACKAGE_2]: {
        id: CREDITS_PACKAGE_2,
        price: '29.90',
        creditsToPurchase: 150,
    },
    [CREDITS_PACKAGE_3]: {
        id: CREDITS_PACKAGE_3,
        price: '49.90',
        creditsToPurchase: 300,
    },
};

export const getCreditsLabel = data => {
    const config = {
        [CREDITS_ACTION_USER_NOT_AVAILABLE]: 'Bonus-Credits',
        [CREDITS_ACTION_JOIN_DATE_REACHED_THRESHOLD]: 'Treuegeschenk',
        [CREDITS_ACTION_USER_BIRTHDAY]: 'Geburtstagsgeschenk',
        [CREDITS_ACTION_LISTING_PUBLISHED]: 'Erstes Profil',
        [CREDITS_ACTION_PROFILE_VERIFIED]: 'Profil verifiziert',
        [CREDITS_ACTION_AVAILABILITY_CONFIRMED]: 'Verfügbarkeit bestätigt',
        [CREDITS_ACTION_PROFILE_COMPLETE]: 'Profil vervollständigt',
        [CREDITS_ACTION_NEW_RECOMMENDATION_RECEIVED]: 'Empfehlung erhalten',
        [CREDITS_ACTION_REFERRAL_INVITER]: 'Weiterempfehlung',
        [CREDITS_ACTION_REFERRAL_INVITED_USER]: 'Weiterempfehlung',
        [CREDITS_ACTION_TOP_UP]: 'Kauf',
        [CREDITS_ACTION_WITHDRAW]: 'Match',
        [CREDITS_ACTION_INITIAL_PURCHASE]: 'Startguthaben',
        [CREDITS_ACTION_VISITOR_INFO_REVEALED]: 'Aufgedeckte Ansicht',
        [CREDITS_SPONSORED_INQUIRY_ACTIVATION]: 'Geschenktes Match',
        [CREDITS_SPONSORED_INQUIRY_REFUND]: 'Rückerstattung',
        [CREDITS_FLIP_AND_WIN_BONUS_CREDITS]: 'Bonus-Credits',
        [CREDITS_EXTRA_PACKAGE_SOCIAL_BOOSTING]: 'Social Boost',
        [CREDITS_EXTRA_PACKAGE_ANONYM_LISTING]: 'Anonymes Profil',
        [CREDITS_EXTRA_PACKAGE_PRIVATE_LISTING]: 'Privates Profil',
        [CREDITS_EXTRA_PACKAGE_SOCIAL_BOOST_PROFILE]: 'Social Boost',
        [CREDITS_EXTRA_PACKAGE_ANONYM_PROFILE]: 'Anonymes Profil',
        [CREDITS_EXTRA_PACKAGE_PRIVATE_PROFILE]: 'Privates Profil',
        [CREDITS_ACTION_FB_CONTENT_SHARED]: 'Bonus-Credits',
        [CREDITS_ACTION_WHATSAPP_CONTENT_SHARED]: 'Bonus-Credits',
    };

    return config[data.eventName];
};

export const getCreditsNotificationData = (eventPayload, currentUser) => {
    const { eventName, extraFields = {}, threshold = 1, total: eventTotal } = eventPayload;
    const { total: extraFieldTotal } = extraFields;
    const { inviterData = {}, invitedUserData = {} } = extraFields;
    const { firstName: invitedUserName } = invitedUserData;
    const { firstName: inviterName } = inviterData;
    const total = eventTotal || extraFieldTotal;

    const { userType } = currentUser?.attributes?.profile?.publicData || {};
    const userTypeHorseowner = 'horseowner'; // same as in the config file
    const isHorseowner = userTypeHorseowner === userType;

    const config = {
        [CREDITS_ACTION_FB_CONTENT_SHARED]: {
            heading: `Glückwunsch! ${total} Credits sind auf dem Weg zu dir.`,
            description: isHorseowner
                ? `Vielen Dank fürs Teilen deines Pferde-Profils! Dafür kriegst Du von uns ${total} Credits gutgeschrieben.`
                : `Vielen Dank fürs Teilen deines Reiter-Profils! Dafür kriegst Du von uns ${total} Credits gutgeschrieben.`,
        },
        [CREDITS_ACTION_WHATSAPP_CONTENT_SHARED]: {
            heading: `Glückwunsch! ${total} Credits sind auf dem Weg zu dir.`,
            description: isHorseowner
                ? `Vielen Dank fürs Teilen deines Pferde-Profils! Dafür kriegst Du von uns ${total} Credits gutgeschrieben.`
                : `Vielen Dank fürs Teilen deines Reiter-Profils! Dafür kriegst Du von uns ${total} Credits gutgeschrieben.`,
        },
        [CREDITS_ACTION_NEW_RECOMMENDATION_RECEIVED]: {
            heading: 'Glückwunsch! 20 Credits kostenlos für dich.',
            description:
                'Du hast deine erste Empfehlung für dein Profil erhalten! Dafür gibt’s von uns 20 Credits kostenlos.',
        },
        [CREDITS_ACTION_REFERRAL_INVITER]: {
            heading: `Glückwunsch! 50 Credits kostenlos für dich.`,
            description: `Du hast ${invitedUserName} überzeugt, sich bei HorseDeal zu registrieren! Dafür gibt’s von uns ein grosses Dankeschön und 50 Credits kostenlos.`,
        },
        [CREDITS_ACTION_REFERRAL_INVITED_USER]: {
            heading: `Glückwunsch! 100 Credits kostenlos für dich.`,
            description: `Du hast dich dank ${inviterName} bei HorseDeal registriert! Dafür gibt’s von uns ein grosses Dankeschön und 100 Credits kostenlos.`,
        },
        [CREDITS_ACTION_INITIAL_PURCHASE]: {
            heading: `Glückwunsch! 50 Credits kostenlos für dich.`,
            description: `Du hast dein Konto bei HorseDeal erfolgreich erstellt! Dafür gibt’s von uns ein grosses Dankeschön und 50 Credits kostenlos.`,
        },
        [CREDITS_ACTION_PROFILE_COMPLETE]: {
            heading: `Glückwunsch! 20 Credits kostenlos für dich.`,
            description: `Dein Konto ist jetzt vollständig! Dafür gibt’s von uns 20 Credits kostenlos.`,
        },
        [CREDITS_ACTION_AVAILABILITY_CONFIRMED]: {
            heading: `Glückwunsch! 20 Credits kostenlos für dich.`,
            description: `Du hast deine Verfügbarkeit erfolgreich bestätigt. Dafür gibt’s von uns 20 Credits kostenlos. `,
        },
        [CREDITS_ACTION_PROFILE_VERIFIED]: {
            heading: `Glückwunsch! 20 Credits kostenlos für dich.`,
            description: `Dein Konto ist jetzt verifiziert! Dafür gibt’s von uns 20 Credits kostenlos.`,
        },
        [CREDITS_ACTION_LISTING_PUBLISHED]: {
            heading: `Glückwunsch! 20 Credits kostenlos für dich.`,
            description: `Dein erstes Profil wurde veröffentlicht! Um dies zu feiern, gibt’s von uns 20 Credits kostenlos.`,
        },
        [CREDITS_ACTION_USER_BIRTHDAY]: {
            heading: `Happy Birthday! 20 Credits kostenlos für dich.`,
            description: `Wir wünschen dir ein tolles Geburtstagsfest. Als kleines Geschenk gibt’s von uns 20 Credits kostenlos.`,
        },
        [CREDITS_ACTION_JOIN_DATE_REACHED_THRESHOLD]: {
            heading: `Happy Jubiläum! 20 Credits kostenlos für dich.`,
            description: `Du bist bereits seit ${Math.round(threshold) *
                12} Monaten Teil von HorseDeal. Als Dankeschön für deine Treue gibt’s von uns 20 Credits kostenlos.`,
        },
        [CREDITS_ACTION_USER_NOT_AVAILABLE]: {
            heading: `Willkommen zurück! 20 Credits kostenlos für dich.`,
            description: `Bereit dein perfektes Match zu finden? Um direkt loszulegen, erhältst Du von uns 20 Credits kostenlos.`,
        },
        [CREDITS_ACTION_TOP_UP]: {
            heading: `Neue Credits hinzugefügt`,
            description: `Die gekauften ${total} Credits wurden soeben deinem Konto gutgeschrieben.`,
            isNotFree: true,
        },
        [CREDITS_FLIP_AND_WIN_BONUS_CREDITS]: {
            heading: `Glückwunsch! ${total} Credits ab sofort nutzbar.`,
            description: `Wir hoffen, deine Glückssträhne hält an! Deine ${total} Credits aus Flip & Win haben wir gutgeschrieben.`,
        },
    };

    return { ...(config[eventName] || {}), id: CREDITS_MODAL_NOTIFICATION };
};
